import React from 'react';
import { Box } from '@material-ui/core';

import './ErrorsContainer.scss'
import errorWarning from '../../images/icon_warning.gif'
import { withTranslation } from 'react-i18next';

export default withTranslation()(function ErrorsContainer({errors, t}) {
    console.log("Object.getOwnPropertyNames(errors): ", Object.getOwnPropertyNames(errors));
    if(Object.getOwnPropertyNames(errors).length>0){

        const getDifferentError = (errors)=>{
            const errorSet = new Set();
            Object.getOwnPropertyNames(errors).forEach((error, index)=>{
                if(errors[error].message){
                    errorSet.add(errors[error].message);
                }
            })
            return Array.from(errorSet);
        }

        return (
            <Box
            border={1}
            borderColor="primary.grey" 
            p={5}
            mb={5}
            className="errorPanel">
                <div className="errorText">
                    <img src={errorWarning} alt="error" /> {t("common.error")}
                    <ul>
                        {
                            getDifferentError(errors).map((errorMsg, index)=>(
                                <li key={index}>{errorMsg}</li>
                            ))
                        }
                    </ul>
                </div>
            </Box>
        )
    } else {
        return (null);
    }
})